import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import utils from '../utils'
import SideBar from '../components/dashboard/SideBar'
import OverviewTab from '../components/dashboard/OverviewTab'
import HousesTab from '../components/dashboard/HousesTab'
import BookingsTab from '../components/dashboard/BookingsTab'

function DashboardPage() {
    const [currentTab, setCurrentTab] = useState(0)
    return (
        <div>
            <Helmet>
                <title>Admin Dashboard - {utils.siteName}</title>
            </Helmet>
            <div className="max-w-7xl mx-auto px-8 mt-10">
                <div className="flex flex-col md:flex-row gap-8">
                    <div className='md:w-3/12'>
                        <SideBar
                            currentTab={currentTab}
                            setCurrentTab={setCurrentTab}
                        />
                    </div>
                    <div className="md:w-9/12">
                        {currentTab === 0 && (
                            <OverviewTab/>
                        )}
                        {currentTab === 1 && (
                            <HousesTab />
                        )}
                        {currentTab === 2 && (
                            <BookingsTab />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DashboardPage